import React from "react";
import Header from "../../components/Header"; 
import Footer from "../../components/Footer";
import UserLeftSidebar from "../Components/UserLeftSidebar"; 
import Myordertable from "../Layouts/Myordertable";



export default function OrderDetail() {
  return (
    <div>
      <Header mode="dark" />

      <div className="container-fluid">
        <div className="dashboard-full-page">
      
      <UserLeftSidebar />

      <Myordertable />

       </div>
      </div>

 
      <Footer />
    </div>
  );
}

